// ASAHI overlay (asahi-5 §0): ヘッダ SSO セッションか（cookie は concern が sign_in 時に設置）。
// 偽装しても UI が隠れる方向にしか効かない（認可には使わない）。
export const isAsahiSsoSession = () =>
  document.cookie.split('; ').includes('asahi_sso=1');
